import React from 'react';
import './sec1.css'
import pic5 from '../assets/pic5.png'
import pic6 from '../assets/pic6.png'
import pic7 from '../assets/pic7.png'
import pic8 from '../assets/pic8.png'
import pic9 from '../assets/pic9.png'
import { useState } from 'react';

const Sec1 = () => {

 const [inView, setInView] = useState(false);

  const handleScroll = () => {
    const section = document.querySelector('.sec1');
    if (!section) return;
    const rect = section.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
    if (isVisible !== inView) setInView(isVisible);
  };


  setTimeout(() => {
    handleScroll();
  }, 50);



    return ( 
        <section className='sec1'>
            <article className={`container-sec1 ${inView ? 'animate' : ''}`}>
                    <article className='text-box-sec1'>
                        <h1 className='header-sec1'>
                            C<span className="yellow-letter">o</span>co <br/>
                            Chan<span className="yellow-letter">el</span>
                            </h1>
                        <article className='small-text-cont-sec1'>
                            <div className='rect-sec1'></div>
                            <article className='main-text-sec1'>
                                    <h2 className='small-text-sec1'>A French fashion designer </h2>
                                    <h2 className='small-text-sec1'>1883-1971</h2>
                            </article>
                        </article>
                    </article>

                    <figure className='img-container-sec1'>
                        <img  className={`img1 ${inView ? 'animate' : ''}`} src={pic5} alt='pic'></img>
                        <img className={`img2 ${inView ? 'animate' : ''}`} src={pic6} alt='img'></img>
                        <img className={`img3 ${inView ? 'animate' : ''}`} src={pic7} alt='img'></img>
                        <img className={`img4 ${inView ? 'animate' : ''}`} src={pic8} alt='img'></img>
                        <img className={`img5 ${inView ? 'animate' : ''}`} src={pic9} alt='img'></img>
                        <div className='circle-cont'>
                  <svg className={`circle-sec1 ${inView ? 'animate' : ''}`} viewBox="0 0 200 200">
                    <circle
                        className="circle-bg"
                        cx="100"
                        cy="100"
                        r="90"
                        fill="#DAAB2D"
                        stroke="#DAAB2D"
                        strokeWidth="0"
                        strokeDasharray="565.48"
                        strokeDashoffset="565.48"
                    />
                    </svg>
                           </div>
                    </figure>  


            </article>
        </section>
     );
}
 
export default Sec1;